// extracted by mini-css-extract-plugin
export default {"unread":"ChatsFilters_unread__RkxMC","search":"ChatsFilters_search__fWprj","checkboxesContainer":"ChatsFilters_checkboxesContainer__5zV8y"};